module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("老师合同")])], 1)], 1)]), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.formData.contractVersionId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contractVersionId", $$v)
      },
      expression: "formData.contractVersionId"
    }
  }, _vm._l((_vm.formData.versionList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 4
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formData.enabled),
      callback: function($$v) {
        _vm.$set(_vm.formData, "enabled", $$v)
      },
      expression: "formData.enabled"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("禁用")])], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('quillEditor', {
    ref: "myQuillEditor",
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "change": _vm.textChange
    },
    model: {
      value: (_vm.formData.contract),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contract", $$v)
      },
      expression: "formData.contract"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      marginTop: '10px'
    }),
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onBack
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    style: ({
      marginLeft: '10px',
      marginRight: '10px'
    }),
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.openPreview
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsert
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-632576e9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/data/TchContract.vue
// module id = 1854
// module chunks = 8